import React from "react";
import { Box, Chip, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    border: `1px solid ${theme.palette.primary.main}`,
    height: "50px",
    borderRadius: "10px",
  },
}));

interface FilterChipProps {
  label: string;
  onDelete?: () => void;
}

export const FilterChip = ({ label, onDelete }: FilterChipProps) => {
  const classes = useStyles();

  if (onDelete) {
    return <Chip label={label} onDelete={() => onDelete && onDelete()} />;
  } else {
    return <Chip label={label} />;
  }
};
